/**
 * Represents the Header component for the application.
 *
 * @component
 * @description This component displays the header of the application, including the logo, application title, and
 * user profile information. It also provides navigation functionality to redirect the user to the home page.
 * 
 * @param {Object} props - The component props.
 * @param {Object} props.history - The history object used for navigation.
 * @returns {React.ReactElement} A header element with the logo, title, and user profile icon.
 */
import React from "react";
import { withRouter } from "react-router-dom";
// import logo from "../../Content/images/logo3.png";
import classes from "./Header.module.css";
import ProfileIcon from "../../Content/images/profile_icon.svg"
import { Urls } from "../../Urls";
import { useAuthValue } from "../../AuthContext";

const Header = ({ history }) => {
  const { currentUser } = useAuthValue();
  const username = currentUser?.displayName || "";

  return (
    <div id="header" className={classes.header}>
      <div
        onClick={() =>
          history.push({
            pathname: "/",
          })
        }
      >
        <img src={Urls.LorriLogoLogin} alt="lorri" className={classes["logo-img"]} />
      </div>
      <div className={classes["header-title"]}>LoRRI Procure</div>
      <div className={classes.actions}>
        <img src={ProfileIcon} alt="" style={{ height: "30px", width: "30px" }} />
        <span className={classes["user-icon"]}>
          {username}
        </span>
      </div>
    </div>
  );
};

export default withRouter(Header);